export const version = "abstract-signer/5.6.2";
//# sourceMappingURL=_version.js.map